import React, { useState, useRef, useEffect } from 'react';

export default function BurgerMenu({ setStep }) {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const timeoutRef = useRef();

  const openMenu = () => {
    setVisible(true);
    setTimeout(() => setOpen(true), 10); // allow render before animating
  };

  const closeMenu = () => {
    setOpen(false);
    timeoutRef.current = setTimeout(() => {
      setVisible(false);
      // setOpen(false);
    }, 400); // Animation duration
  };

  React.useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);

  return (
    <div className="fixed top-4 left-4 z-50">
      <button
        className={`transition-colors duration-200 bg-blue-700 hover:bg-blue-800 border-none rounded-full p-2 shadow-lg focus:outline-none flex items-center justify-center ${open ? 'ring-2 ring-blue-400' : ''}`}
        onClick={() => visible ? closeMenu() : openMenu()}
        aria-label="Menü öffnen"
        style={{ width: 44, height: 44 }}
      >
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="6" width="28" height="2.5" rx="1.25" fill="#fff" />
          <rect y="13" width="28" height="2.5" rx="1.25" fill="#fff" />
          <rect y="20" width="28" height="2.5" rx="1.25" fill="#fff" />
        </svg>
      </button>
      {visible && (
        <>
          <div
            className={`fixed inset-0 z-40 transition-opacity duration-400 ${open ? 'opacity-50 animate-fade-in-overlay' : 'opacity-0 animate-fade-out-overlay'}`}
            onClick={closeMenu}
            style={{ animation: `${open ? 'fadeInOverlay' : 'fadeOutOverlay'} 0.4s`, visibility: open ? 'visible' : 'hidden' }}
          />
          <div className={`absolute top-12 left-0 w-60 bg-white rounded-2xl shadow-2xl border border-gray-200 py-6 px-4 z-50 ${open ? 'animate-fade-in' : 'animate-fade-out'}`} style={{ animation: `${open ? 'fadeInMenu' : 'fadeOutMenu'} 0.4s`, visibility: open ? 'visible' : 'hidden' }}>
            <nav className="flex flex-col gap-3">
              <button onClick={() => { setStep(-1); closeMenu(); }} className="w-full text-left px-5 py-3 rounded-lg hover:bg-blue-50 font-semibold text-blue-700 transition-colors duration-150 text-lg">Startseite</button>
              <button onClick={() => { setStep(1); closeMenu(); }} className="w-full text-left px-5 py-3 rounded-lg hover:bg-blue-50 font-semibold text-blue-700 transition-colors duration-150 text-lg">Bestellung</button>
              <button onClick={() => { setStep('order-history'); closeMenu(); }} className="w-full text-left px-5 py-3 rounded-lg hover:bg-blue-50 font-semibold text-blue-700 transition-colors duration-150 text-lg">Bestellhistorie</button>
            </nav>
          </div>
          <style>{`
            @keyframes fadeInMenu {
              from { opacity: 0; transform: translateY(-10px); }
              to { opacity: 1; transform: translateY(0); }
            }
            @keyframes fadeOutMenu {
              from { opacity: 1; transform: translateY(0); }
              to { opacity: 0; transform: translateY(-10px); }
            }
            @keyframes fadeInOverlay {
              from { opacity: 0; }
              to { opacity: 0.5; }
            }
            @keyframes fadeOutOverlay {
              from { opacity: 0.5; }
              to { opacity: 0; }
            }
          `}</style>
        </>
      )}
    </div>
  );
};


